import React, { ComponentType } from "react";

import style from "./style.module.scss";
import { CenteredModal, Spinner } from "../../../ui";
import LoginButton from "../login-button";
import { useAuth } from "../../../data/context/auth-context";

interface RequireLoginOptions {
  role?: "admin" | "client";
}

const requireLogin = (options?: RequireLoginOptions) => {
  return <P extends object>(WrappedComponent: ComponentType<P>) => {
    const ComponentWithLogin: React.FC<P> = (props) => {
      const { isAuthenticated, profile, loading } = useAuth();

      if (loading) {
        return (
          <CenteredModal className={style.container}>
            <Spinner />
          </CenteredModal>
        );
      }

      if (!isAuthenticated) {
        return (
          <CenteredModal className={style.container}>
            <div className={style.login}>
              <p>Connecter vous pour accèder à cette page</p>
              <LoginButton />
            </div>
          </CenteredModal>
        );
      }

      if (options?.role && profile?.role !== options.role) {
        return (
          <CenteredModal className={style.container}>
            <h2 className={style.accessDenied}>Accès non autorisé</h2>
          </CenteredModal>
        );
      }

      return <WrappedComponent {...props} />;
    };

    ComponentWithLogin.displayName = `RequireLogin(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

    return ComponentWithLogin;
  };
};

export default requireLogin;
